import(/* webpackMode: "eager" */ "/pp/app/poln_web/src/assets/styles/scss/_userDeal.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/pp/app/poln_web/src/components/Deals/DealsContent.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/pp/app/poln_web/src/components/Deals/DealsLayout.js");
